import { CardioOrResistance, FoodPreference, Level, WorkoutType } from 'fitbeat.models';
import i18n from './i18n';

export const getSkillLevelText: { [key: string]: Level } = {
  [Level.Beginner]: i18n.t('bookings:beginner'),
  [Level.Basic]: i18n.t('bookings:intermediate'),
  [Level.Intermediate]: i18n.t('bookings:advanced'),
};

export const getNutritionPreferenceText: { [key: string]: FoodPreference } = {
  [FoodPreference.Vegetarian]: i18n.t('nutrition:Vegetarian'),
  [FoodPreference.Vegan]: i18n.t('nutrition:Vegan'),
  [FoodPreference.AllFoodGroups]: i18n.t('nutrition:AllFoodGroups'),
  [FoodPreference.HighProtein]: i18n.t('nutrition:HighProtein'),
};

export const getWorkoutTypeText: { [key: string]: CardioOrResistance } = {
  [CardioOrResistance.Cardio]: i18n.t('bookings:burn'),
  [CardioOrResistance.Resistance]: i18n.t('bookings:build'),
  [CardioOrResistance.Balance]: i18n.t('bookings:balance'),
};

export const getWorkoutDuration: { [key: string]: WorkoutType } = {
  [WorkoutType.QuickHomeOrStaticCardioWorkout]: i18n.t('bookings:15min'),
  [WorkoutType.MediumHomeOrStaticCardioWorkout]: i18n.t('bookings:27min'),
  [WorkoutType.FullHomeOrStaticCardioWorkout]: i18n.t('bookings:40min'),
  [WorkoutType.FullStudioWorkout]: i18n.t('bookings:46min'),
  [WorkoutType.MediumStudioWorkout]: i18n.t('bookings:28Min'),
};

export const getWorkoutDurationDescription: { [key: string]: WorkoutType } = {
  [WorkoutType.QuickHomeOrStaticCardioWorkout]: i18n.t('bookings:quick'),
  [WorkoutType.MediumHomeOrStaticCardioWorkout]: i18n.t('bookings:medium'),
  [WorkoutType.FullHomeOrStaticCardioWorkout]: i18n.t('bookings:full'),
};

export const getBodyGroupText = (bodyGroups: string[]): string => {
  return (bodyGroups.length === 0 || bodyGroups.length === 3)
    ? i18n.t('bookings:fullBody')
    : bodyGroups.join(' + ');
};
